// utils/optionMapper.js
export const mapToOptions = (data = [], valueKey, labelKey) =>
  data.map((item) => ({
    value: item[valueKey],
    label: labelKey == 'academicYear' ? `${item[labelKey]} (${item.currentAY === 1 ? "Active" : "Inactive"})` : item[labelKey],
    ...item
  }));

